<template>
  <div class="page-content">
    <iframe
      style="height: 100vh; width: 100%"
      v-if="brandDashboard && brandDashboard.length"
      :src="`https://bionix.cixxonia.com${brandDashboard[0].full_url}`"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "Brand",
  data() {
    return {
      brandDashboard: null,
    };
  },
  beforeMount() {
    this.$store.dispatch("setSideMenu", "brand_menu");
  },
  async mounted() {
    try {
      this.brandDashboard = await this.$api.common.getDashboard();
    } catch (error) {
      console.error(error);
    }
  },
};
</script>
